module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-165-min.dafea918.jpg";